module.exports = __webpack_public_path__ + "static/media/cartoon-profile.38568c84.png";